export default {
    description:
        "W programie Polecaj i zarabiaj <b>czeka na Ciebie <span>{receiverBonusAmount}</span> bonusu</b> za Twoje pierwsze zakupy!",
    captchaLanguage: "pl",
    email: "Podaj e-mail",
    password: "Podaj hasło",
    showMore: "Czytaj więcej",
    showLess: "Ukryj",
    userConsentError: "To oświadczenie jest wymagane",
    passwordRequired: "Hasło jest wymagane",
    passwordTooShort: "Hasło powinno mieć co najmniej 6 znaków",
    emailRequired: "E-mail jest wymagany",
    emailInvalid: "Wprowadź poprawny adres e-mail",
    emailTooLong: "Adres e-mail nie może zawierać więcej niż {maxSize} znaków",
    modalConfirmationButton: "Dalej",
    popularCashbackBrands: {
        title: "<b>Popularne sklepy</b> z cashback",
        subTitle: "Cashback za zakupy odbierzesz w blisko <b>600 sklepach</b> internetowych!",
    },
    whatIsCashback: {
        title: "Czym jest <b>cashback</b>",
        subTitle:
            "Gdy robisz zakupy w sklepach internetowych, <b>część wydanych pieniędzy możesz otrzymać z powrotem</b> – to właśnie cashback. W goodie znajdziesz prawie 600 znanych sklepów internetowych, w których dostaniesz cashback.",
    },
    forgetPassword: "Zapomniałeś hasła?",
    bannerTitle: "<b>Otrzymuj zwroty pieniędzy</b> za zakupy",
    bannerText: "Rób zakupy w ulubionych sklepach internetowych i otrzymuj zwroty części wydanych pieniędzy.",
    socialLoginError:
        "Nie znaleźliśmy konta goodie, na które możesz się zalogować. Skorzystaj z formularza rejestracji i załóż nowe konto.",
};
